import React from 'react'
import { GridRow } from 'src/components/Reusable/Grid'
import {
  bannerHeight,
  filterBarHeight,
  headerContentHeight,
} from 'src/components/PageLayout/dimensionUtils'
import { useBannerContext } from 'src/context/Banner/BannerContext'
import { RiskGridColumnSort } from 'src/components/Reusable/Grid/GridColumnSort/RiskGridColumnSort'
import {
  GridColumnSortRisks,
  GridColumnSortType,
} from 'src/components/Reusable/Grid/GridColumnSort/GridColumnSort.constants'
import { useRisksContext } from '../context/RisksContext'
import { StyledRisksGridHeader } from '../risks.styles'
import { RISK_HEADERS } from '../risks.constants'

export const RisksGridHeader = (): JSX.Element => {
  const { bannerCount } = useBannerContext()
  const { sortType } = useRisksContext()
  const sortHeaders: string[] = Object.keys(GridColumnSortRisks)
  return (
    <GridRow>
      {RISK_HEADERS.map((header: { name: string }) => (
        <StyledRisksGridHeader
          key={header.name}
          $top={
            headerContentHeight + filterBarHeight + bannerCount * bannerHeight
          }
          justifyContent="flex-start"
        >
          {header.name}
          {sortHeaders.includes(header.name) && (
            <RiskGridColumnSort
              type={sortType as GridColumnSortType}
              colName={
                GridColumnSortRisks[
                  header.name as keyof typeof GridColumnSortRisks
                ]
              }
            />
          )}
        </StyledRisksGridHeader>
      ))}
    </GridRow>
  )
}
